import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { GET_USERS, GET_USERS_SUCCESS, GET_USERS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getUsers({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/users`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParam,
        pageIndex: payload?.urlParam?.pageIndex,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_USERS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_USERS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_USERS_ERROR, payload: error });
  }
}

export function* watchUsers() {
  yield takeEvery(GET_USERS, getUsers);
}

function* usersSaga() {
  yield all([fork(watchUsers)]);
}

export default usersSaga;
